<template>
  <div>
    <div class="feedback">
      <transition name="fade" @enter="enterErrorFeedback">
        <FeedbackError v-if="showableErrorFeedback" :message="errorMessage" />
      </transition>
    </div>
    <IndexPageTopCoverSection />
    <IndexPageNoticeSection :target="target" />
    <IndexPageEspeciallyRecommendSection />
    <IndexPageRecommendSection />
    <IndexPageBrandSection />
    <IndexPageSpecialListSection @error="onSectionError" />
    <div class="dual_section">
      <IndexPageSceneListSection />
      <IndexPageReceivingKindsSection />
    </div>
    <IndexPageNewArrivalSection />
    <IndexPageCardDesignSection />
    <IndexPageCategoriesSection @error="onSectionError" />
    <IndexPageBackToTopSection @click-link="onClickBackTopLink" />
  </div>
</template>
<script>
import IndexPageTopCoverSection from '../../organism/homes/sections/IndexPageTopCoverSection'
import IndexPageNoticeSection from '../../organism/homes/sections/IndexPageNoticeSection'
import IndexPageRecommendSection from '../../organism/homes/sections/IndexPageRecommendSection'
import IndexPageBrandSection from '../../organism/homes/sections/IndexPageBrandSection'
import IndexPageSpecialListSection from '../../organism/homes/sections/IndexPageSpecialListSection'
import IndexPageNewArrivalSection from '../../organism/homes/sections/IndexPageNewArrivalSection'
import IndexPageCardDesignSection from '../../organism/homes/sections/IndexPageCardDesignSection'
import IndexPageSceneListSection from '../../organism/homes/sections/IndexPageSceneListSection'
import IndexPageReceivingKindsSection from '../../organism/homes/sections/IndexPageReceivingKindsSection'
import IndexPageCategoriesSection from '../../organism/homes/sections/IndexPageCategoriesSection'
import IndexPageBackToTopSection from '../../organism/homes/sections/IndexPageBackToTopSection'
import FeedbackError from '../../atoms/feedbacks/feedback-error'
import IndexPageEspeciallyRecommendSection from '../../organism/homes/sections/IndexPageEspeciallyRecommendSection'

export default {
  components: {
    IndexPageEspeciallyRecommendSection,
    IndexPageTopCoverSection,
    IndexPageNoticeSection,
    IndexPageRecommendSection,
    IndexPageBrandSection,
    IndexPageSpecialListSection,
    IndexPageNewArrivalSection,
    IndexPageCardDesignSection,
    IndexPageSceneListSection,
    IndexPageReceivingKindsSection,
    IndexPageCategoriesSection,
    IndexPageBackToTopSection,
    FeedbackError
  },
  props: {
    redirectSourceErrorMessage: {
      type: String,
      required: true
    },
    deliveryUrl: {
      type: String,
      required: true
    },
    target: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showableErrorFeedback: false
    }
  },
  mounted() {
    this.showableErrorFeedback = this.redirectSourceErrorMessage.length !== 0
    this.errorMessage = this.redirectSourceErrorMessage
  },
  methods: {
    moveToUrl(url) {
      location.href = url
      this.closeModal()
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    onSectionError(message) {
      this.errorMessage = message
      this.showableErrorFeedback = true
    },
    onClickBackTopLink() {
      window.scrollTo({ top, behavior: 'smooth' })
    }
  }
}
</script>
